import { AddressLine, FullAddress, constructStreetValue } from '../../../services/als'
import { AccountAddress } from '../../azure-b2c/storage'

export interface CreateDeliveryInfoProps {
  selectedAddressLine: AddressLine | undefined
  selectedFullAddress: FullAddress | undefined

  addressName: string | undefined
  addressShort: string | undefined
  selectedKnownAddress: AccountAddress | undefined
}

export const createDeliveryInfo = ({
  selectedAddressLine,
  selectedFullAddress,
  selectedKnownAddress,
  addressName,
  addressShort,
}: CreateDeliveryInfoProps) => {
  let deliveryInfo = {}
  if (selectedAddressLine && selectedFullAddress) {
    deliveryInfo = {
      addressName: addressName,
      city: selectedFullAddress.TownCity,
      streetAddress: constructStreetValue(selectedFullAddress),
      postCode: selectedFullAddress.Postcode,
      address: addressShort,
      isNewAddress: true,
    }
  } else if (selectedKnownAddress) {
    deliveryInfo = {
      addressName: selectedKnownAddress.name,
      city: selectedKnownAddress.city,
      streetAddress: selectedKnownAddress.street,
      postCode: selectedKnownAddress.zipCode,
      address: selectedKnownAddress.fullAddress,
      recordId: selectedKnownAddress.recordId,
      isNewAddress: false,
    }
  }

  return deliveryInfo
}
